import { type ReactNode, Suspense } from 'react';
import ErrorBoundaryComponent from '../ErrorBoundaryComponent/ErrorBoundaryComponent';
import { LoadingSpinner } from '../../LoadingSpinner/LoadingSpinner';

interface SuspenseComponentProps {
  children?: ReactNode;
}

const SuspenseComponent = (props: SuspenseComponentProps) => {
  const { children } = props;

  return (
    <ErrorBoundaryComponent>
      <Suspense fallback={<LoadingSpinner />}>{children}</Suspense>
    </ErrorBoundaryComponent>
  );
};

export default SuspenseComponent;
